import { Brand, createBranded } from '@deltasierra/type-utilities';

export type SocialPublishContentId = Brand<number, 'SocialPublishContentId'>;
export const SocialPublishContentId = createBranded<SocialPublishContentId>();
